import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface RejectIdentificationUserResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}

export function rejectIdentificationUserAction(userId: string): Promise<ApiResponse<RejectIdentificationUserResponse>> {
  return api.put<ApiResponse<RejectIdentificationUserResponse>>(`/users/${userId}/reject-identification`)
}
